import { render, staticRenderFns } from "./NewTariffSelectedContent.vue?vue&type=template&id=ee4b6a32&scoped=true"
import script from "./NewTariffSelectedContent.vue?vue&type=script&lang=ts"
export * from "./NewTariffSelectedContent.vue?vue&type=script&lang=ts"
import style0 from "./NewTariffSelectedContent.vue?vue&type=style&index=0&id=ee4b6a32&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4b6a32",
  null
  
)

export default component.exports